import React from "react";

import { Stack, useTheme } from "@bps/fluent-ui";

import { RolloutDevicesAssignedTable } from "./RingDevicesAssignedTable";
import { RingDevicesAssignedTableFilter } from "./RingDevicesAssignedTableFilter";

interface DevicesAssignedProps {
  deploymentRingId: string;
}

export const DevicesAssigned: React.FC<DevicesAssignedProps> = ({
  deploymentRingId
}) => {
  const theme = useTheme();
  return (
    <Stack
      tokens={{ childrenGap: theme.spacing.m }}
      styles={{ root: { width: "25%" } }}
    >
      {/* Devices section */}
      <RingDevicesAssignedTableFilter deploymentRingId={deploymentRingId}>
        {({ values }) => {
          return (
            <RolloutDevicesAssignedTable
              deploymentRingId={deploymentRingId}
              filter={values}
            />
          );
        }}
      </RingDevicesAssignedTableFilter>
    </Stack>
  );
};
